{
  "toolbar": {
    "blockTypes": {
      "paragraph": "Párrafo",
      "quote": "Cita",
      "heading_one": "H1",
      "heading_two": "H2",
      "heading_three": "H3",
      "heading_four": "Título",
      "heading_five": "Subtítulo",
      "heading_six": "Bajada"
    },
    "blockTypeSelect": {
      "selectBlockTypeTooltip": "Selecciona",
      "placeholder": "Tipo"
    },
    "toggleGroup": "Conmutar grupo",
    "removeBold": "Borrar negrita",
    "bold": "Negrita",
    "removeItalic": "Borrar cursiva",
    "italic": "Cursiva",
    "underline": "Borrar subrayado",
    "removeUnderline": "Subrayado",
    "removeInlineCode": "Borrar formato de código",
    "inlineCode": "Formato de código en línea",
    "link": "Crear enlace",
    "richText": "Texto enriquecido",
    "diffMode": "Modo diferencial",
    "source": "Modo fuente",
    "admonition": "Insertar admonición",
    "codeBlock": "Insertar bloque de código",
    "editFrontmatter": "Editar frontmatter",
    "insertFrontmatter": "Insertar frontmatter",
    "image": "Insertar imagen",
    "insertSandpack": "Insertar Sandpack",
    "table": "Insertar tabla",
    "thematicBreak": "Insertar salto de línea",
    "bulletedList": "Lista con viñetas",
    "numberedList": "Lista numerada",
    "checkList": "Lista de verificación",
    "deleteSandpack": "Borrar este bloque de código",
    "undo": "Deshacer {{shortcut}}",
    "redo": "Rehacer {{shortcut}}"
  }
}
